import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EarbudsBatteryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"earbuds_battery"}/>
}
